// extracted by mini-css-extract-plugin
export default {"header":"styles_header__VItT8","active":"styles_active__rN10L","headerNav":"styles_headerNav__xsrTA","headerNavList":"styles_headerNavList__orwaV"};